import React from "react";

const VisitorRegSetup = () => {
  return <div>Visitor Reg Settings</div>;
};

export default VisitorRegSetup;
